/* Nuvō product page skin: see snippets/nuvo-pdp.liquid */
(() => {
  const info = document.querySelector('.template__product .product__info');
  if (!info) return;
  document.documentElement.classList.add('npd');

  /* ---------- Option tiles ----------
     Each option <select> gets a row of tile buttons. Clicking a tile sets the select and fires
     "change", so the theme's variant logic, price updates and the gas-type guard keep working. */
  const variantsJson = info.querySelector('variant-selects script[type="application/json"]');
  const variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

  const imagesFor = (select) => {
    const wrap = select.closest('[data-option-index]');
    if (!wrap) return null;
    const i = +wrap.dataset.optionIndex;
    const map = {};
    variants.forEach((v) => {
      const val = v.options[i];
      if (!map[val] && v.featured_image) map[val] = v.featured_image.src;
    });
    const values = [...select.options].map((o) => o.value);
    return values.every((v) => map[v]) && new Set(Object.values(map)).size > 1 ? map : null;
  };

  const sized = (src) => src + (src.includes('?') ? '&' : '?') + 'width=200';

  /* ---------- Fire table textures ----------
     A fire table is chosen in two textures, the top and the base. Their tiles show The Outdoor Plus's own
     finish swatches (Dealer Portal "[12] Color Swatches"; Rustic Coffee from theoutdoorplus.com), packed in
     assets/nuvo-swatches-top.jpg, 6 x 4 cells in this order. A value with no swatch of the same name gets none. */
  let specData = {};
  try { specData = JSON.parse(document.getElementById('npd-spec-data').textContent); } catch (e) { /* no data */ }
  const SWATCH_COLS = 6, SWATCH_ROWS = 4;
  const SWATCHES = {
    gfrc: ['Black', 'Natural Gray', 'Limestone', 'Chocolate', 'Rustic Gray', 'Rustic White', 'Rustic Coffee', 'Metallic Bronze',
      'Metallic Pearl', 'Metallic Silver', 'Woodgrain Ebony', 'Woodgrain Ivory', 'Woodgrain Oak'],
    pc: ['Glossy Black', 'Graphite Gray', 'Gray', 'Pewter', 'Mist', 'Soft White', 'White', 'Java', 'Bronze Hammertone', 'Copper Vein', 'Silver Vein']
  };
  /* Videl names The Outdoor Plus's Glossy Black just "Black" on its cooking tables */
  const SWATCH_ALIAS = { pc: { Black: 'Glossy Black' } };
  const swatchIndex = (family, value) => {
    const i = SWATCHES[family].indexOf((SWATCH_ALIAS[family] || {})[value] || value);
    return i < 0 ? -1 : (family === 'pc' ? SWATCHES.gfrc.length : 0) + i;
  };
  /* Nov 3 2026: GFRC finishes the sprite has no cell for, as single images in Shopify Files
     (TOP Dealer Portal "[01] GFRC Concrete", 1100px centre crop, 240px) */
  const SWATCH_EXTRA = { gfrc: {
    Ash: 'https://cdn.shopify.com/s/files/1/0701/0015/6502/files/nuvo-gfrc-ash.jpg?v=1793694060',
    Chestnut: 'https://cdn.shopify.com/s/files/1/0701/0015/6502/files/nuvo-gfrc-chestnut.jpg?v=1793694060'
  } };
  const hasSwatch = (family, value) => swatchIndex(family, value) >= 0 || !!(SWATCH_EXTRA[family] || {})[value];
  /* which part of the table an option dresses, and in which material */
  const textureFor = (select) => {
    if (!specData.swatches) return null;
    const name = (select.closest('.product-form__input')?.querySelector('label')?.textContent || '').split(':')[0].trim().toLowerCase();
    /* a Videl island's or cooking table's Color is a powder coat: swatch tiles, but no fire-table drawing (parts: []).
       Nov 2 2026: any other product's Color or Base Color gets the same powder-coat tiles too (Round Atlas was the first).
       It only reaches here when the option has no photo for every color (product photos win, see imagesFor), and the
       tiles only appear when every value has a TOP swatch of the same name, so products shot in each color are untouched.
       Nov 3 2026: a Color whose values are all GFRC finishes (Sedona 360 Spill) gets the GFRC tiles instead. */
    const values = [...select.options].map((o) => o.value).filter(Boolean);
    const all = (family) => values.every((v) => hasSwatch(family, v));
    const part = specData.fireTable
      ? { 'top finish': { family: 'gfrc', parts: ['top'] }, 'base color': { family: 'pc', parts: ['base'] }, finish: { family: 'pc', parts: ['top', 'base'] } }[name]
      : { color: { family: all('pc') ? 'pc' : 'gfrc', parts: [] }, 'base color': { family: 'pc', parts: [] } }[name];
    if (!part) return null;
    return all(part.family) ? { ...part, select } : null;
  };
  /* the sprite cell for a swatch, scaled so one cell is `size` px wide */
  const swatchStyle = (family, value, size) => {
    const i = swatchIndex(family, value);
    const extra = (SWATCH_EXTRA[family] || {})[value];
    if (i < 0) return extra ? `background-image:url("${extra}");background-size:cover;background-position:center` : '';
    return `background-image:url("${specData.swatches}");background-size:${SWATCH_COLS * size}px ${SWATCH_ROWS * size}px;`
      + `background-position:-${(i % SWATCH_COLS) * size}px -${Math.floor(i / SWATCH_COLS) * size}px`;
  };
  const textures = [];

  const buildTiles = (select) => {
    if (select.dataset.npdTiles) return;
    select.dataset.npdTiles = '1';
    const images = imagesFor(select);
    const tex = images ? null : textureFor(select);
    if (tex) textures.push(tex);
    const group = document.createElement('div');
    group.className = 'npd-tiles' + (images || tex ? ' npd-tiles--img' : '');
    group.setAttribute('role', 'group');
    const label = select.closest('.product-form__input')?.querySelector('label');
    if (label) group.setAttribute('aria-label', label.textContent.split(':')[0].trim());

    [...select.options].forEach((opt) => {
      if (!opt.value) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'npd-tile';
      b.dataset.value = opt.value;
      b.innerHTML = (images ? `<span class="npd-tile__img"><img src="${sized(images[opt.value])}" alt="" loading="lazy"></span>` : '') +
        (tex ? `<span class="npd-tile__img npd-tile__tex" data-swatch="${tex.family}"></span>` : '') +
        '<span class="npd-tile__check" aria-hidden="true"><svg viewBox="0 0 12 12" width="9" height="9"><path d="m2.5 6.2 2.3 2.3 4.7-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        `<span class="npd-tile__label"></span>`;
      b.querySelector('.npd-tile__label').textContent = opt.textContent.trim();
      if (tex) b.querySelector('.npd-tile__tex').style.cssText = swatchStyle(tex.family, opt.value, 120);
      b.addEventListener('click', () => {
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      group.appendChild(b);
    });

    const sync = () => group.querySelectorAll('.npd-tile').forEach((b) => {
      const opt = [...select.options].find((o) => o.value === b.dataset.value);
      b.setAttribute('aria-pressed', String(select.value === b.dataset.value));
      b.disabled = !!(opt && opt.disabled);
    });
    select.addEventListener('change', sync);
    sync();

    const selWrap = select.closest('.select');
    selWrap.after(group);
    selWrap.classList.add('npd-hidden-select');
  };

  const config = info.querySelector('.product__info-block--variant_picker:not([hidden])');
  const allSelects = () => info.querySelectorAll('.product__info-block--variant_picker select.select__select, [data-nuvo-field] select');

  /* The gas-type / base-color fields join the options card when there is one. They are placed after
     <variant-selects>, never inside it, so the theme's variant matching only ever sees real options. */
  if (config) {
    const head = document.createElement('div');
    head.className = 'npd-card-head';
    head.innerHTML = '<p class="npd-card-title">Configure your piece</p>';
    config.prepend(head);
    info.querySelectorAll('[data-nuvo-field]').forEach((f) => config.appendChild(f));
  }
  allSelects().forEach(buildTiles);

  /* Nov 1: a "Countertop color" relabel for Videl islands was removed. Which part each Color option finishes
     is unconfirmed; it is with Christian to check with Videl before any label names a part. */
  /* "Propane tank not included" wherever a piece can run on propane: under a Fuel Type option, and on cooking
     tables, which are propane only. Pieces tagged Gas Selectable already carry it (snippets/nuvo-config-guard.liquid). */
  const tankNote = () => { const p = document.createElement('p'); p.className = 'nuvo-field-note'; p.style.cssText = 'margin:.4rem 0 0;font-size:.8rem;line-height:1.45;color:#111'; p.innerHTML = '<strong style="font-weight:600">Propane tank not included.</strong>'; return p; };
  info.querySelectorAll('.product__info-block--variant_picker .product-form__input').forEach((w) => {
    const name = (w.querySelector('label')?.textContent || '').split(':')[0].trim().toLowerCase();
    /* Nov 3 2026: also a real Gas Type option (Cazo 360 / Sedona 360 Spill carry gas as variants, not the guard) */
    if ((name === 'fuel type' || name === 'gas type') && !w.querySelector('.nuvo-field-note')) w.appendChild(tankNote());
  });
  if (specData.cookingTable && config && !config.querySelector('.nuvo-field-note')) {
    const fields = config.querySelectorAll('variant-selects .product-form__input');
    (fields[fields.length - 1] || config).appendChild(tankNote());
  }

  /* "Your combination": a drawing of the table with each part filled in its chosen texture, kept in step
     with the tiles. Shown only when both the top and the base have swatches. */
  const dressed = (part) => textures.find((t) => t.parts.includes(part));
  if (config && dressed('top') && dressed('base')) {
    const MATERIAL = { gfrc: 'GFRC concrete', pc: 'Powder coat' };
    const combo = document.createElement('div');
    combo.className = 'npd-combo';
    /* The Alameda drawn in three-quarter view from its studio photo: a thick slab with a stainless burner
       pan of lava rock down the middle, two pedestals set in from the ends (a vertical step on each front,
       the access door on the right pedestal's end), joined by a recessed crossbar. Each face is filled with
       its texture, skewed to the plane it lies in, and shaded by a soft overlay. */
    /* texture cell size: the top's cell spans the whole slab (no repeat seams); the base keeps the finer grain
       of powder coat, each pedestal sitting inside one cell */
    const SW = { top: 400, base: 160 };
    const P = (u, v) => [20 + 230 * u + 50 * v, 78 - 28 * v];
    const pts = (a) => a.map((q) => q.map((n) => +n.toFixed(1)).join(',')).join(' ');
    const dn = (q, h) => [q[0], q[1] + h];
    const T = 12, H = 70;
    const face = (part, plane, poly, shade) => `<polygon points="${pts(poly)}" fill="url(#npdc-${part}-${plane})"/>`
      + (shade ? `<polygon points="${pts(poly)}" fill="${shade}"/>` : '');
    const pedestal = (u0, u1, v0, v1, door) => {
      const a = dn(P(u0, v0), T), b = dn(P(u1, v0), T), c2 = dn(P(u1, v1), T);
      const front = [a, b, dn(b, H), dn(a, H)], side = [b, c2, dn(c2, H), dn(b, H)];
      const seam = dn(P(u0 + (u1 - u0) * 0.24, v0), T);
      let out = face('base', 'side', side, 'rgba(0,0,0,.32)') + face('base', 'front', front, 'rgba(0,0,0,.06)')
        + `<line x1="${seam[0]}" y1="${seam[1]}" x2="${seam[0]}" y2="${seam[1] + H}" stroke="rgba(0,0,0,.35)" stroke-width="1.2"/>`
        + `<line x1="${seam[0] + 1.2}" y1="${seam[1]}" x2="${seam[0] + 1.2}" y2="${seam[1] + H}" stroke="rgba(255,255,255,.12)" stroke-width=".8"/>`;
      if (door) {
        const s0 = (k, h) => { const q = [b[0] + (c2[0] - b[0]) * k, b[1] + (c2[1] - b[1]) * k]; return [q[0], q[1] + h]; };
        out += `<polygon points="${pts([s0(0.32, H * 0.3), s0(0.86, H * 0.3), s0(0.86, H * 0.95), s0(0.32, H * 0.95)])}" fill="none" stroke="rgba(0,0,0,.4)" stroke-width="1"/>`;
      }
      return out;
    };
    /* soft, overlapping tongues of flame along the pan, an outer orange layer and a shorter yellow core */
    const flames = (scale) => {
      const [x0, y0] = P(0.23, 0.5), [x1] = P(0.77, 0.5);
      const hs = [14, 22, 17, 26, 19, 15, 24, 20, 28, 17, 23, 18, 25, 14, 20, 16];
      const lean = [1, -1, 2, 0, -2, 1, -1, 2, 0, -1, 1, -2, 1, 0, -1, 1];
      const n = hs.length, step = (x1 - x0) / n;
      return hs.map((h0, i) => {
        const h = h0 * scale, w = step * 1.9, xa = x0 + step * i - step * 0.45, xb = xa + w, xm = (xa + xb) / 2 + lean[i] * scale;
        const f = (n2) => n2.toFixed(1);
        return `M${f(xa)},${y0} C${f(xa + w * 0.12)},${f(y0 - h * 0.45)} ${f(xm - w * 0.28)},${f(y0 - h * 0.72)} ${f(xm)},${f(y0 - h)}`
          + ` C${f(xm + w * 0.2)},${f(y0 - h * 0.62)} ${f(xb - w * 0.1)},${f(y0 - h * 0.38)} ${f(xb)},${y0}Z`;
      }).join(' ');
    };
    const pattern = (part, plane, m) => `<pattern id="npdc-${part}-${plane}" patternUnits="userSpaceOnUse" width="${SW[part]}" height="${SW[part]}" patternTransform="translate(20 40) matrix(${m})">`
      + `<image href="${specData.swatches}" width="${SW[part] * SWATCH_COLS}" height="${SW[part] * SWATCH_ROWS}" preserveAspectRatio="none"/></pattern>`;
    const planes = { top: '1 0 0.87 -0.49 0 0', front: '1 0 0 1 0 0', side: '0.87 -0.49 0 1 0 0' };
    const defs = ['top', 'base'].map((part) => Object.entries(planes).map(([plane, m]) => pattern(part, plane, m)).join('')).join('')
      + '<linearGradient id="npdc-flame" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#D9661C"/><stop offset=".45" stop-color="#F09A2E"/><stop offset="1" stop-color="#F8C455" stop-opacity=".55"/></linearGradient>'
      + '<linearGradient id="npdc-core" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#FFE9A8"/><stop offset="1" stop-color="#FFD271" stop-opacity=".2"/></linearGradient>'
      + '<filter id="npdc-soft" x="-10%" y="-20%" width="120%" height="140%"><feGaussianBlur stdDeviation=".45"/></filter>'
      + '<radialGradient id="npdc-floor"><stop offset="0" stop-color="#1F1C19" stop-opacity=".3"/><stop offset="1" stop-color="#1F1C19" stop-opacity="0"/></radialGradient>';
    const slabTop = [P(0, 0), P(1, 0), P(1, 1), P(0, 1)];
    const slabFront = [P(0, 0), P(1, 0), dn(P(1, 0), T), dn(P(0, 0), T)];
    const slabSide = [P(1, 0), P(1, 1), dn(P(1, 1), T), dn(P(1, 0), T)];
    const pan = [P(0.2, 0.36), P(0.8, 0.36), P(0.8, 0.64), P(0.2, 0.64)];
    const lava = [P(0.21, 0.4), P(0.79, 0.4), P(0.79, 0.6), P(0.21, 0.6)];
    const bar = [dn(P(0.3, 0.32), T), dn(P(0.7, 0.32), T), dn(P(0.7, 0.32), T + 26), dn(P(0.3, 0.32), T + 26)];
    const floorY = P(0, 0.5)[1] + T + H;
    const art = `<svg class="npd-combo__svg" viewBox="0 0 320 172" role="img" aria-label="Alameda fire table in your chosen finishes"><defs>${defs}</defs>`
      + `<ellipse cx="165" cy="${floorY + 2}" rx="150" ry="10" fill="url(#npdc-floor)"/>`
      + face('base', 'front', bar, 'rgba(0,0,0,.38)')
      + pedestal(0.08, 0.3, 0.18, 0.82, false) + pedestal(0.7, 0.92, 0.18, 0.82, true)
      + face('top', 'side', slabSide, 'rgba(0,0,0,.26)') + face('top', 'front', slabFront, 'rgba(0,0,0,.05)') + face('top', 'top', slabTop, 'rgba(255,255,255,.06)')
      + `<polyline points="${pts([P(0, 0), P(1, 0), P(1, 1)])}" fill="none" stroke="rgba(255,255,255,.28)" stroke-width=".8"/>`
      + `<polygon points="${pts(pan)}" fill="#3A3632" stroke="#B9B4AC" stroke-width="1.2"/>`
      + `<polygon points="${pts(lava)}" fill="#1E1B19"/>`
      + `<g filter="url(#npdc-soft)"><path d="${flames(1)}" fill="url(#npdc-flame)" opacity=".92"/><path d="${flames(0.55)}" fill="url(#npdc-core)"/></g>`
      + '</svg>';
    combo.innerHTML = '<p class="npd-combo__title">Your combination</p>'
      + `<div class="npd-combo__art">${art}</div>`
      + '<dl class="npd-combo__legend"><div><dt>Top</dt><dd data-part="top"></dd></div><div><dt>Base</dt><dd data-part="base"></dd></div></dl>'
      + '<p class="npd-combo__note">Finish samples from The Outdoor Plus.</p>';
    config.querySelector('.npd-card-head').after(combo);
    const paint = () => ['top', 'base'].forEach((part) => {
      const t = dressed(part);
      const v = t.select.value;
      const i = swatchIndex(t.family, v);
      combo.querySelectorAll(`pattern[id^="npdc-${part}-"] image`).forEach((img) => {
        img.setAttribute('x', i < 0 ? 0 : -(i % SWATCH_COLS) * SW[part]);
        img.setAttribute('y', i < 0 ? 0 : -Math.floor(i / SWATCH_COLS) * SW[part]);
      });
      combo.querySelector(`dd[data-part="${part}"]`).textContent = v ? `${v} · ${/^Woodgrain/.test(v) ? 'GFRC woodgrain' : MATERIAL[t.family]}` : 'Choose below';
    });
    textures.forEach((t) => t.select.addEventListener('change', paint));
    paint();
  }

  /* ---------- A note on color ----------
     Every product: screens show color differently, so the finish chosen here may look slightly different in
     person. Calm, and it points to support rather than promising samples. It closes the options card, where
     the finish is chosen; products without options carry it under the buy buttons. */
  const colorNote = document.createElement('p');
  colorNote.className = 'npd-colornote';
  colorNote.innerHTML = '<strong>A note on color.</strong> We show every finish as faithfully as we can, but screens display color differently, '
    + 'so what you see may vary slightly from the finished piece. Questions about a finish or color? Email '
    + '<a href="mailto:support@nuvo-living.com">support@nuvo-living.com</a> and we\u2019ll help you choose with confidence.';
  const buy = info.querySelector('.product__info-block--buy_buttons');
  if (config) config.appendChild(colorNote);
  else if (buy) { colorNote.style.order = buy.style.order; buy.after(colorNote); }

  /* ---------- Price chips ---------- */
  const tpl = document.getElementById('npd-chips');
  const price = info.querySelector('.product__info-block--price') || info.querySelector('.product__title--price');
  if (tpl && price) {
    const chips = tpl.content.firstElementChild.cloneNode(true);
    /* blocks are placed with inline flex "order", so the chips borrow the price block's */
    chips.style.order = price.style.order;
    price.after(chips);
  }

  /* ---------- Review stars ----------
     Judge.me's star block (an app block in the theme editor) sits under the title and best-seller seal. The title
     block also holds the SKU and price, so on its own the block would land between the price and the financing line.
     Judge.me hides it while a product has no reviews. */
  const stars = info.querySelector('.product__info-block--app .jdgm-preview-badge');
  const sku = info.querySelector('.product__title--wrapper .product__title--sku');
  if (stars && sku) {
    const block = stars.closest('.product__info-block--app');
    block.classList.add('npd-stars');
    sku.before(block);
  }

  /* ---------- Mini recommendations ----------
     Desktop: fills the empty column under the photos with 8 cards (two rows of four).
     Below 990px there is no side column, so the same cards become a swipeable strip where the
     theme's "You may also like" section sits. Either way that theme section is hidden once this renders.
     The mix is half Shopify's related products and half picks from the other main categories, so a
     fire-pit shopper also sees outdoor kitchens and water features.
     Fire pits, tables and bowls get a first row of their own, "Finish your fire feature": fire media and
     accessories from the fire-media-accessories collection (a glass, a pebble or lava stone, an ornament, and the
     remote only when the piece offers an electronic ignition). Single-option accessories add in place. */
  const gallery = info.querySelector('.product__info-block--gallery');
  const recsSection = document.querySelector('[id$="__product-recommendations"]');
  const productId = +info.querySelector('[data-product-id]')?.dataset.productId;
  const desktop = matchMedia('(min-width: 990px)').matches;
  const miniHost = desktop ? gallery : recsSection;
  const CATEGORIES = ['fire-features', 'outdoor-kitchens', 'water-features'];
  const ACCESSORIES = 'fire-media-accessories';
  const FIRE_TYPES = ['Fire Pits', 'Fire Pits & Tables', 'Fire Bowls'];
  const ACCESSORY_TYPES = ['Fire Media', 'Fire Ornaments', 'Fire Feature Controls'];
  const ELECTRONIC = /electronic|low voltage|plug & play/i;
  const MINI_COUNT = 8;
  if (miniHost && productId) {
    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    const getJson = (url) => fetch(url).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    const shuffle = (a) => a.map((v) => [Math.random(), v]).sort((x, y) => x[0] - y[0]).map((x) => x[1]);
    /* /recommendations returns prices in cents; /collections/…/products.json returns them as "3790.00" */
    const fromRecs = (p) => ({ id: p.id, title: p.title, url: p.url, img: p.featured_image, cents: p.price_min ?? p.price, varies: p.price_varies });
    const fromCollection = (p) => {
      const prices = p.variants.map((v) => Math.round(parseFloat(v.price) * 100));
      const single = p.variants.length === 1 && p.variants[0].available;
      return {
        id: p.id, title: p.title, url: `/products/${p.handle}`, img: p.images[0]?.src, cents: Math.min(...prices), varies: new Set(prices).size > 1,
        type: p.product_type, tags: p.tags || [], options: p.options || [], variantId: single ? p.variants[0].id : null,
      };
    };

    Promise.all([
      getJson(`/recommendations/products.json?product_id=${productId}&limit=${MINI_COUNT}&intent=related`),
      ...CATEGORIES.map((c) => getJson(`/collections/${c}/products.json?limit=50`)),
      getJson(`/collections/${ACCESSORIES}/products.json?limit=50`),
    ]).then(([recs, ...cats]) => {
      const related = ((recs && recs.products) || []).map(fromRecs);
      const accessories = (((cats.pop() || {}).products) || []).map(fromCollection);
      const lists = cats.map((c) => ((c && c.products) || []).map(fromCollection));
      const own = lists.findIndex((l) => l.some((p) => p.id === productId));
      const self = lists.flat().concat(accessories).find((p) => p.id === productId);
      const isFire = !!self && FIRE_TYPES.includes(self.type);
      const isAccessory = !!self && ACCESSORY_TYPES.includes(self.type);
      /* an accessory page looks back at the fire features and the rest of the range, not at outdoor kitchens */
      const others = (isAccessory ? [lists[0], accessories] : lists.filter((_, i) => i !== own)).map(shuffle);

      const seen = new Set([productId]);
      const take = (p) => (p && p.img && !seen.has(p.id) ? (seen.add(p.id), p) : null);

      /* "Finish your fire feature": one of each kind of finish, so the row reads as a set rather than four glasses */
      const finish = [];
      if (isFire && accessories.length) {
        const pool = shuffle(accessories);
        const has = (p, t) => p.tags.includes(t);
        const electronic = self.options.some((o) => /ignition/i.test(o.name) && o.values.some((v) => ELECTRONIC.test(v)));
        const kinds = [
          (p) => has(p, 'Fire Glass'),
          (p) => has(p, 'Fire Pebbles') || has(p, 'Lava Rock'),
          (p) => p.type === 'Fire Ornaments',
          electronic ? (p) => p.type === 'Fire Feature Controls' : (p) => p.type === 'Fire Media',
        ];
        kinds.forEach((k) => { const p = pool.find((q) => k(q) && take(q)); if (p) finish.push(p); });
        pool.forEach((p) => { if (finish.length < 4 && p.type !== 'Fire Feature Controls' && take(p)) finish.push(p); });
      }
      /* related and other-category picks alternate so the first row already shows the variety */
      const rel = related.filter(take).slice(0, MINI_COUNT / 2);
      const perCat = Math.ceil((MINI_COUNT - rel.length) / Math.max(others.length, 1));
      const extra = [];
      for (let k = 0; k < perCat; k++) others.forEach((l) => { const p = l.find(take); if (p) extra.push(p); });
      const items = [];
      for (let k = 0; items.length < MINI_COUNT && (k < rel.length || k < extra.length); k++) {
        if (rel[k]) items.push(rel[k]);
        if (extra[k] && items.length < MINI_COUNT) items.push(extra[k]);
      }
      /* with a finish row on top, the second row keeps four cards so the block stays two rows tall */
      if (finish.length) items.splice(MINI_COUNT - finish.length);
      if (!items.length && !finish.length) return;

      const box = document.createElement('aside');
      box.className = 'npd-mini' + (desktop ? '' : ' npd-mini--strip');
      box.setAttribute('aria-label', 'You may also like');
      const addGroup = (heading, list, sub) => {
        if (!list.length) return;
        const title = document.createElement('p');
        title.className = 'npd-mini__title';
        title.textContent = heading;
        box.appendChild(title);
        if (sub) {
          const note = document.createElement('p');
          note.className = 'npd-mini__sub';
          note.innerHTML = sub;
          box.appendChild(note);
        }
        const grid = document.createElement('ul');
        grid.className = 'npd-mini__grid';
        list.forEach((p) => {
          const li = document.createElement('li');
          li.innerHTML = `<a class="npd-mini__card" href="${p.url}"><span class="npd-mini__img"><img src="${p.img}${p.img.includes('?') ? '&' : '?'}width=300" alt="" loading="lazy"></span><span class="npd-mini__name"></span><span class="npd-mini__price"></span></a>`;
          /* "Coronado Fire Pit | The Outdoor Plus" reads as "Coronado Fire Pit" at this size */
          li.querySelector('.npd-mini__name').textContent = p.title.split(' | ')[0];
          li.querySelector('.npd-mini__price').textContent = (p.varies ? 'From ' : '') + money(p.cents);
          /* accessories with a single option add straight from the card; the rest open their page to choose a size */
          if (sub && p.variantId) {
            const add = document.createElement('button');
            add.type = 'button';
            add.className = 'npd-mini__add';
            add.textContent = 'Add';
            add.setAttribute('aria-label', `Add ${p.title.split(' | ')[0]} to cart`);
            add.addEventListener('click', () => {
              add.disabled = true;
              add.textContent = 'Adding';
              /* nuvoQuiet: the button's own "Added" is the feedback, not the full add-to-cart moment */
              fetch('/cart/add.js', { method: 'POST', nuvoQuiet: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: p.variantId, quantity: 1 }) })
                .then((r) => {
                  if (!r.ok) throw new Error(r.status);
                  add.textContent = 'Added';
                  add.classList.add('is-added');
                  const sidebar = document.getElementById('cart-sidebar');
                  if (sidebar && sidebar.reload) sidebar.reload();
                })
                .catch(() => { add.disabled = false; add.textContent = 'Add'; });
            });
            li.appendChild(add);
          }
          grid.appendChild(li);
        });
        box.appendChild(grid);
      };
      addGroup('Finish your fire feature', finish, 'The glass, stone and accessories that finish a fire feature.');
      addGroup('You may also like', items);
      if (desktop) gallery.appendChild(box);
      else recsSection.before(box);
      document.documentElement.classList.add('npd-has-mini');
    });
  }

  /* ---------- Arrival from a hero card ----------
     snippets/nuvo-pdp-enter.liquid painted the hero's full-screen photo before anything else. Here it becomes
     a real element, the name fades, and the photo shrinks into the gallery while the page appears around it. */
  /* A page prerendered on hover runs this script before the visitor arrives; the head snippet then fires npd-enter. */
  const arrive = () => {
    const enter = window.__npdEnter;
    if (!enter || window.__npdEnterTaken || !document.documentElement.classList.contains('npd-entering')) return;
    window.__npdEnterTaken = true;
    try { sessionStorage.removeItem('nuvo-enter'); } catch (err) {}
    const EASE = 'cubic-bezier(.76,0,.24,1)';
    /* cubic-bezier(x1,y1,x2,y2) as a function of progress, for keyframes sampled ahead of time */
    const bezier = (x1, y1, x2, y2) => {
      const at = (a, b, t) => ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t;
      return (x) => {
        let lo = 0, hi = 1, t = x;
        for (let i = 0; i < 24; i++) { t = (lo + hi) / 2; if (at(x1, x2, t) < x) lo = t; else hi = t; }
        return at(y1, y2, t);
      };
    };
    const z = document.createElement('div');
    z.className = 'npd-enter';
    z.setAttribute('aria-hidden', 'true');
    z.innerHTML = '<img alt=""><span class="npd-enter__veil"></span><span class="npd-enter__cap"><span class="npd-enter__name"></span><span class="npd-enter__rule"></span></span>';
    const zi = z.querySelector('img');
    zi.src = enter.src;
    zi.onerror = () => { zi.src = enter.low; };
    zi.style.objectPosition = enter.pos || '50% 50%';
    z.querySelector('.npd-enter__name').textContent = enter.name || '';
    document.body.appendChild(z);
    document.documentElement.classList.remove('npd-entering');
    window.scrollTo(0, 0);

    const target = gallery && gallery.querySelector('.slider-component__inner');
    /* The name stays alone for about 0.2s once the pitch is gone, then closing starts, without waiting for
       the gallery image to decode; the photo shrinks over it either way. */
    const hold = Math.max(0, Math.min(400, (enter.bare || 0) + 200 - Date.now()));
    /* the photo's real proportions are needed to land it exactly; its decode (usually instant, it is cached from the
       hero) runs alongside the hold and is never waited on for more than 0.3s */
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    const decoded = zi.decode ? zi.decode().catch(() => {}) : Promise.resolve();
    const ready = Promise.all([wait(hold), Promise.race([decoded, wait(300)])]).then(() => new Promise((r) => requestAnimationFrame(() => r())));
    ready.then(() => {
      const r = target ? target.getBoundingClientRect() : null;
      z.querySelector('.npd-enter__cap').animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-16px)' }], { duration: 120, easing: EASE, fill: 'forwards' });
      z.querySelector('.npd-enter__veil').animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, fill: 'forwards' });
      document.querySelector('.template__product')?.animate([{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }], { duration: 700, delay: 120, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' });
      /* Lands on the gallery when it is on screen; otherwise it simply dissolves into the page. */
      const lands = r && r.width && r.top < innerHeight && r.bottom > 0;
      /* Transform only, so phones and iPads run it on the compositor: the overlay box shrinks onto the gallery while
         a stage inside it is scaled by exactly the inverse (sampled ahead along the same curve), so the photo stays
         at screen scale and the box just closes in on it, as a clip-path would without Safari repainting it every
         frame. The photo meanwhile settles into the gallery, ending cover-cropped to the gallery box. */
      let move, landRadius = '';
      if (lands) {
        const W = innerWidth, H = innerHeight;
        /* exactly the visible viewport (100vh runs taller than it under a phone's address bar) */
        z.style.height = H + 'px';
        const ref = target.querySelector('img');
        const iw = zi.naturalWidth || (ref && (ref.naturalWidth || +ref.getAttribute('width'))) || r.width;
        const ih = zi.naturalHeight || (ref && (ref.naturalHeight || +ref.getAttribute('height'))) || r.height;
        /* The photo element takes its full cover size (looks identical), since object-fit would otherwise crop it
           to the screen's box and leave it too narrow for the gallery once scaled down. */
        const [, opx = 50, opy = 50] = /([\d.]+)%\s+([\d.]+)%/.exec(enter.pos || '') || [];
        const S = Math.max(W / iw, H / ih), cw = iw * S, ch = ih * S;
        const left = (W - cw) * opx / 100, top = (H - ch) * opy / 100;
        /* max-width/height: the theme caps every img at 100% of its box */
        Object.assign(zi.style, { inset: 'auto', maxWidth: 'none', maxHeight: 'none', willChange: 'transform', objectFit: 'fill', width: cw.toFixed(2) + 'px', height: ch.toFixed(2) + 'px', left: left.toFixed(2) + 'px', top: top.toFixed(2) + 'px' });
        const k = Math.max(r.width / iw, r.height / ih) / S;
        const dx = r.left + r.width / 2 - (left + cw / 2), dy = r.top + r.height / 2 - (top + ch / 2);
        const stage = document.createElement('div');
        stage.style.cssText = `display:block;position:absolute;top:0;left:0;width:${W}px;height:${H}px;transform-origin:0 0;will-change:transform`;
        while (z.firstChild) stage.appendChild(z.firstChild);
        z.appendChild(stage);
        Object.assign(z.style, { transformOrigin: '0 0', willChange: 'transform' });
        const ease = bezier(.76, 0, .24, 1);
        const boxK = [], stageK = [];
        for (let n = 0, N = 20; n <= N; n++) {
          const e = ease(n / N);
          const bx = r.left * e, by = r.top * e;
          const sx = (W + (r.width - W) * e) / W, sy = (H + (r.height - H) * e) / H;
          boxK.push({ transform: `translate(${bx}px, ${by}px) scale(${sx}, ${sy})` });
          stageK.push({ transform: `scale(${1 / sx}, ${1 / sy}) translate(${-bx}px, ${-by}px)` });
        }
        z.animate(boxK, { duration: 600, fill: 'forwards' });
        /* the gallery's 14px corners, written in the box's own (scaled) units so they come out round on screen */
        landRadius = `${14 * W / r.width}px / ${14 * H / r.height}px`;
        stage.animate(stageK, { duration: 600, fill: 'forwards' });
        move = zi.animate([{ transform: 'none' }, { transform: `translate(${dx}px, ${dy}px) scale(${k})` }], { duration: 600, easing: EASE, fill: 'forwards' });
      } else {
        move = z.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }], { duration: 400, easing: EASE, fill: 'forwards' });
      }
      move.finished.then(() => { if (landRadius) z.style.borderRadius = landRadius; }).then(() => z.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, easing: 'ease', fill: 'forwards' }).finished).then(() => z.remove(), () => z.remove());
    });
  };
  arrive();
  document.addEventListener('npd-enter', arrive);

  /* ---------- Description tabs ----------
     Every product gets the same four tabs. The description is one rich-text block whose sections start with h2 or h3
     headings; each section is filed under a tab by its heading, in its original order, so nothing is lost:
       Specifications         Features, Specifications, Details, Dimensions, Required clearances, Island cutout, Prop 65
       Guides & Installation  How it installs, Two ways to install it, Caring for a GFRC top; then the manuals note
       FAQ                    Frequently Asked Questions (the store-wide ordering questions when a product has none)
       Product Description    the opening text and everything else (Build Your Fire Pit, What's Included...)
     Specifications opens with a grid: the product's type and options, then each line of its spec lists split into a
     label and a value ("Burners: 2", "Top — glass fiber reinforced concrete"). Features follows as a list. */
  const rte = document.querySelector('.product-section-tabs .expanded-inner .tab-content .rte');
  if (rte) {
    const tabs = {
      desc: { title: 'Product Description', sects: [] },
      specs: { title: 'Specifications', sects: [] },
      guides: { title: 'Guides & Installation', sects: [] },
      faq: { title: 'FAQ', sects: [] }
    };
    const tabOf = (t) => {
      if (/frequently asked|^faqs?$/i.test(t)) return 'faq';
      if (/^features$|specification|dimension|clearance|cutout|proposition 65|^details$/i.test(t)) return 'specs';
      if (/install|guide|manual|caring|\bcare\b/i.test(t)) return 'guides';
      return 'desc';
    };
    let sect = { heading: null, nodes: [] };
    tabs.desc.sects.push(sect);
    [...rte.childNodes].forEach((n) => {
      if (n.nodeType === 1 && (n.tagName === 'H2' || n.tagName === 'H3')) {
        const t = n.textContent.trim();
        const key = tabOf(t);
        /* a heading that only repeats its tab's name is dropped when it is the tab's only section */
        const repeats = key === 'faq' || t.toLowerCase() === tabs[key].title.toLowerCase();
        sect = { heading: n, repeats, nodes: [] };
        tabs[key].sects.push(sect);
        return;
      }
      sect.nodes.push(n);
    });

    const qa = (q, a) => { const p = document.createElement('p'); p.innerHTML = '<strong>' + q + '</strong><br>' + a; return p; };
    const filled = (s) => s.heading || s.nodes.some((n) => n.nodeType === 1 || n.textContent.trim());
    /* Manuals: The Outdoor Plus's own PDFs (Dealer Portal "[02] Manuals and Documents", in Shopify Files), only the
       ones a buyer needs for this piece: the product's set-up manual and the manual for each ignition it is sold
       with. Videl pieces use the VIDEL map below. */
    let pdpData = {};
    try { pdpData = JSON.parse(document.getElementById('npd-spec-data').textContent); } catch (e) { /* no data */ }
    const FILES = 'https://cdn.shopify.com/s/files/1/0701/0015/6502/files/';
    /* Each card carries the manual's own title from The Outdoor Plus, with the ignition it covers in parentheses
       when the title doesn't say it. Match Lit on fire pits and tables is covered by the Fire Pit Manual (its
       lighting instructions; theoutdoorplus.com links it as their match-lit manual); there is no separate one. */
    const MANUALS = {
      ml: ['TOP-Fire-Pit-Manual.pdf', 'Fire Pit Manual (Match Lit)', 'Gas requirements, set-up, leak test and lighting by hand.', 1.6],
      pnp: ['TOP-Plug-and-Play-Ignition-Manual.pdf', 'Plug & Play Ignition System', 'Installing and operating the push-button system.', 4.7],
      lv: ['TOP-Low-Voltage-12V-Ignition-Manual.pdf', 'Low Voltage Ignition System', 'Installing and operating the 12V electronic system.', 6.1],
      mlfs: ['TOP-Match-Lit-Flame-Sense-Manual.pdf', 'Match Lit with Flame Sense', 'Installation, lighting and the flame-sensing shut-off.', 8.0],
      sparkfs: ['TOP-Spark-Ignition-Flame-Sense-Manual.pdf', 'Flame Sense with Spark Ignition System', 'Installation and push-button spark lighting.', 3.1],
      fbml: ['TOP-Fire-Bowl-Match-Lit-Manual.pdf', 'Fire Bowl Installation (Match Lit)', 'Setting the bowl, gas connection and lighting.', 1.8],
      fblv: ['TOP-Fire-Bowl-Low-Voltage-12V-Manual.pdf', 'Fire Bowl Installation (Low Voltage Ignition System)', 'Setting the bowl, gas connection and the 12V system.', 4.3],
      fwbml: ['TOP-Fire-Water-Bowl-Match-Lit-Manual.pdf', 'Fire Water Bowl Installation (Match Lit)', 'Setting the bowl, gas and water connections, lighting.', 2.3],
      fwblv: ['TOP-Fire-Water-Bowl-Low-Voltage-12V-Manual.pdf', 'Fire Water Bowl Installation (Low Voltage Ignition System)', 'Setting the bowl, gas and water connections, the 12V system.', 4.2],
      selfcontained: ['TOP-Self-Contained-Unit-Manual.pdf', 'Self-Contained Unit', 'Installation, gas connection, start-up and testing.', 2.3],
      paradise: ['TOP-Paradise-Fall-Owners-Manual.pdf', 'Paradise Falls Owner’s Manual', 'Installation, operation and care.', 6.1],
      pfled: ['TOP-Paradise-Fall-LED-Manual.pdf', 'Paradise Falls – LED Installation', 'Installing the LED lighting package.', 1.2],
      torch: ['TOP-Torch-Match-Lit-Manual.pdf', 'Tiki Torch Owner’s Manual (Match Lit)', 'Pole installation, gas shut-off options and lighting.', 3.1],
      /* Videl: owner's manuals from the Videl Dealer Portal "[05] Appliance Manuals", each checked against the
         model numbers inside it (DG-4B36/DG-5B42, VD-DR30, DG-G30, DG-DSB, DG-R20) */
      vgrill: ['Videl-36-42-Grill-Manual.pdf', '36" & 42" Grill User Manual', 'Installation, propane conversion, lighting and care.', 11.2],
      voven: ['Videl-Outdoor-Oven-I-Manual.pdf', 'Outdoor Oven I Use & Care Guide', 'Cutout, clearances, installation and operation.', 6.0],
      vgriddle: ['Videl-30-Griddle-Manual.pdf', '30" Griddle User Manual', 'Installation, propane conversion, lighting and care.', 6.7],
      vdsb: ['Videl-Double-Side-Burner-Manual.pdf', 'Double Side Burner User Manual', 'Installation, propane conversion, lighting and care.', 4.4],
      vfridge: ['Videl-Compact-Refrigerator-Manual.pdf', 'Compact Refrigerator Installation & Operation', 'Electrical requirements, installation, operation and care.', 0.8]
    };
    /* Videl pieces: their owner's manual (when Videl publishes one for that model) and the spec sheet for their
       exact part number (Dealer Portal "[01] Specification Sheets"). Pieces with neither keep the on-request note:
       Santa Barbara, Bellingham, Brasa III island, premium trash chute, audio, outlet, umbrella mount, bottle
       opener, charging station. The Alameda Cooking Table manual is not used: it covers the Anza inside that table
       (its heat shield and cutout), not the drop-in or our tables. [part number, MB, has island cutout] */
    const VIDEL = {
      'videl-brasa-ii-santa-maria-grill': [null, ['BDFSS', 0.2, false]],
      'videl-brasa-iii-drop-in-santa-maria-grill': [null, ['BR3DSS', 0.2, true]],
      'pacific-60-bbq-island': [null, ['PF60I', 0.3, false]],
      'pacific-72-bbq-island': [null, ['PF72I', 0.3, false]],
      'pacific-96-bbq-island': [null, ['PF96I', 0.5, false]],
      'pacific-112-bbq-island': [null, ['PF112I', 0.7, false]],
      /* one sheet for both mirror-image layouts; it draws one of them, the dimensions are the same */
      'alta-72l-r-outdoor-kitchen-island': [null, ['72L-ALTA', 0.1, false]],
      'alta-72l-l-outdoor-kitchen-island': [null, ['72L-ALTA', 0.1, false]],
      '36-4-burner-built-in-grill': ['vgrill', ['4B36', 0.3, true]],
      '42-5-burner-built-in-grill': ['vgrill', ['5B42', 0.3, true]],
      'outdoor-oven-i-pizza-oven': ['voven', ['DR30', 0.3, true]],
      'gran-plancha-i-griddle': ['vgriddle', ['G30', 0.3, true]],
      'fuego-i-double-side-burner': ['vdsb', ['DSB', 0.3, true]],
      'anza-dual-burner-drop-in': [null, ['AZA2', 0.2, true]],
      'videl-table-top-pizza-oven': [null, ['TPZ032', 0.3, true]],
      'videl-outdoor-stainless-steel-refrigerator': [null, ['R32FRG', 0.2, true]],
      'videl-compact-outdoor-refrigerator': ['vfridge', ['R20', 0.2, true]],
      'videl-42-combo-door-and-drawer': [null, ['42DC', 0.2, true]],
      'videl-36-combo-door-and-drawer': [null, ['36DC', 0.2, true]],
      'videl-33-combo-door-and-drawer': [null, ['33DC', 0.2, true]],
      'videl-42-double-door': [null, ['42DD', 0.2, true]],
      'videl-36-double-door': [null, ['36DD', 0.2, true]],
      'videl-30-double-door': [null, ['30DD', 0.2, true]],
      'videl-18-single-access-door': [null, ['18SD', 0.2, true]],
      'videl-multi-function-door': [null, ['MFD', 0.2, true]],
      'videl-triple-access-drawers': [null, ['3D', 0.2, true]],
      'videl-spice-rack-pantry-drawer': [null, ['11SR', 0.2, true]],
      'videl-margarita-center': [null, ['20MC', 0.2, true]],
      'videl-outdoor-sink': [null, ['20SINK', 0.2, true]],
      'videl-trash-chute-standard': [null, ['12TCHE', 0.2, true]]
    };
    const videl = /^videl/i.test(pdpData.vendor || '') ? VIDEL[pdpData.handle] : null;
    if (videl) {
      const [, [part, mb, cutout]] = videl;
      MANUALS.vspec = [`VG-${part}_SpecSheet.pdf`, `Spec Sheet (VG-${part})`, cutout ? 'Overall dimensions and the island cutout.' : 'Overall dimensions.', mb];
    }
    /* One manual per ignition the piece is sold with, in the option's order. Bowls use their own installation
       manuals; everything else uses the ignition system manuals. Pieces sold with a single, fixed ignition get the
       manual for the ignition their own listing states. */
    const manualKeys = (() => {
      if (videl) return [videl[0], 'vspec'];
      if (pdpData.vendor !== 'The Outdoor Plus') return [];
      const h = pdpData.handle || '';
      const ign = ((pdpData.options || []).find((o) => o.name === 'Ignition') || { values: [] }).values;
      const bowl = /fire-water-bowl/.test(h) ? 'fwb' : /fire-bowl/.test(h) ? 'fb' : '';
      const forIgnition = (v) => {
        if (/flame sense/i.test(v)) return /spark/i.test(v) ? 'sparkfs' : 'mlfs';
        if (/plug/i.test(v)) return 'pnp';
        if (/low voltage|12v/i.test(v)) return bowl ? bowl + 'lv' : 'lv';
        if (/match lit/i.test(v)) return bowl ? bowl + 'ml' : 'ml';
        return null;
      };
      if (ign.length) return [...new Set(ign.map(forIgnition))];
      if (/fire-torch/.test(h)) return ['torch'];
      if (/paradise-fall/.test(h)) return /with-led/.test(h) ? ['paradise', 'pfled'] : ['paradise'];
      /* Sedona 360 and Sedona 60 are Low Voltage, like the Cazo pair (confirmed by Marcos, Oct 31 2026) */
      if (/round-atlas|self-contained/.test(h)) return ['selfcontained', 'lv'];
      if (/360-spill/.test(h)) return ['lv'];
      return [];
    })().filter(Boolean);
    const help = document.createElement('p');
    help.className = 'npd-manuals__help';
    if (manualKeys.length) {
      const list = document.createElement('ul');
      list.className = 'npd-manuals';
      manualKeys.forEach((k) => {
        const [file, title, desc, mb] = MANUALS[k];
        const li = document.createElement('li');
        li.innerHTML = `<a class="npd-manual" href="${FILES}${file}" target="_blank" rel="noopener">`
          + '<span class="npd-manual__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 3h7l5 5v13H7z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M14 3v5h5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg><b>PDF</b></span>'
          + '<span class="npd-manual__text"><span class="npd-manual__title"></span><span class="npd-manual__desc"></span></span>'
          + `<span class="npd-manual__meta">${mb.toFixed(1)} MB<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 13l6-6M8 7h5v5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span></a>`;
        li.querySelector('.npd-manual__title').textContent = title;
        li.querySelector('.npd-manual__desc').textContent = desc;
        list.appendChild(li);
      });
      help.innerHTML = videl
        ? (videl[0] ? 'The owner’s manual and spec sheet for this piece, from Videl. Questions before you order?' : 'The spec sheet for this piece, from Videl. Need installation details or anything else before you order?')
          + ' Email <a href="mailto:support@nuvo-living.com"><strong>support@nuvo-living.com</strong></a>.'
        : 'One manual for each ignition offered on this piece, from The Outdoor Plus. Need a spec drawing or anything else before you order? Email <a href="mailto:support@nuvo-living.com"><strong>support@nuvo-living.com</strong></a>.';
      tabs.guides.sects.push({ heading: null, nodes: [list, help] });
    } else {
      /* manuals are sent on request (same note as the "Guides & Manuals" block beside the price) */
      help.innerHTML = 'Installation and operation manuals for this product are available on request. Email <a href="mailto:support@nuvo-living.com"><strong>support@nuvo-living.com</strong></a> and we’ll send them. You can also reach us at (866) 688-0882.';
      tabs.guides.sects.push({ heading: null, nodes: [help] });
    }
    if (!tabs.faq.sects.some(filled)) {
      tabs.faq.sects.push({ heading: null, nodes: [
        qa('Can I cancel or change my order?', 'Within 48 hours, yes — free, any reason, full refund. We hold every made-to-order piece a full 48 hours before releasing it to the manufacturer so this window is real. After that your order is locked into production and cannot be cancelled or returned.'),
        qa('How long until it arrives?', 'Production takes 2–4 weeks, followed by 1–2 weeks of freight transit — approximately <strong>3–6 weeks total</strong> from order to delivery.')
      ] });
    }

    let data = null;
    try { data = JSON.parse(document.getElementById('npd-spec-data').textContent); } catch (e) { /* no data, no summary */ }

    /* California Prop 65: The Outdoor Plus shows this warning on every product page (theoutdoorplus.com, checked
       Oct 31 2026), so all of its pieces carry it, worded exactly as the law's safe-harbor text. The few
       descriptions that already hold it (the Alameda tables) give way to this card so it isn't shown twice. */
    if (data && data.vendor === 'The Outdoor Plus') {
      tabs.specs.sects = tabs.specs.sects.filter((s) => !(s.heading && /proposition 65/i.test(s.heading.textContent)));
      const p65 = document.createElement('aside');
      p65.className = 'npd-p65';
      p65.innerHTML = '<svg class="npd-p65__sign" viewBox="0 0 24 22" aria-hidden="true"><path d="M12 1.5 23 20.5H1Z" fill="#F2C230" stroke="#1F1C19" stroke-width="1.2" stroke-linejoin="round"/><path d="M12 8v6.2" stroke="#1F1C19" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.3" r="1.15" fill="#1F1C19"/></svg>'
        + '<div><p class="npd-p65__title">California Prop 65 Warning</p>'
        + '<p><strong>WARNING:</strong> This product can expose you to chemicals including Lead, Lead Compounds, and Carbon Monoxide which are known to the state of California to cause cancer, birth defects or other reproductive harm. For more information go to <a href="https://www.p65warnings.ca.gov/" target="_blank" rel="nofollow noopener">www.P65Warnings.ca.gov</a>.</p>'
        + '<p lang="es"><strong>ADVERTENCIA:</strong> Este producto puede exponerlo a productos qu\u00edmicos como el plomo, los compuestos de plomo, y el mon\u00f3xido de carbono sabidos por el estado de California como causa de c\u00e1ncer, de defectos de nacimiento u otros da\u00f1os reproductivos. Para obtener m\u00e1s informaci\u00f3n <a href="https://www.p65warnings.ca.gov/" target="_blank" rel="nofollow noopener">www.P65Warnings.ca.gov</a>.</p></div>';
      tabs.specs.sects.push({ heading: null, last: true, nodes: [p65] });
    }

    /* ---- Specifications grid ---- */
    const isFeatures = (s) => s.heading && /^features$/i.test(s.heading.textContent.trim());
    const order = (s) => (s.last ? 2 : isFeatures(s) ? 1 : 0);
    tabs.specs.sects.sort((a, b) => order(a) - order(b));
    const specCell = (label, value) => {
      const row = document.createElement('div');
      row.className = 'npd-specs__row' + (label ? '' : ' npd-specs__row--note');
      if (label) {
        const dt = document.createElement('dt');
        dt.textContent = label;
        row.appendChild(dt);
      }
      const dd = document.createElement('dd');
      if (typeof value === 'string') dd.textContent = value.charAt(0).toUpperCase() + value.slice(1); else dd.innerHTML = value.innerHTML;
      row.appendChild(dd);
      return row;
    };
    const liCell = (li) => {
      const first = li.firstElementChild;
      const lead = li.textContent.slice(0, li.textContent.indexOf(first ? first.textContent : '\u0000')).trim();
      if (first && first.tagName === 'STRONG' && !lead) {
        const label = first.textContent.trim().replace(/:$/, '');
        const value = li.textContent.trim().slice(first.textContent.trim().length).replace(/^\s*[:\u2014\u2013-]\s*/, '').trim();
        if (label && value) return specCell(label, value);
      }
      const t = li.textContent.replace(/\s+/g, ' ').trim();
      const m = t.match(/^([^:]{1,40}):\s+(.+)$/) || t.match(/^(.{1,40}?)\s+[\u2014\u2013]\s+(.+)$/);
      return m ? specCell(m[1].trim(), m[2].trim()) : specCell(null, li);
    };
    const asGrid = (nodes) => nodes.map((n) => {
      if (n.nodeType !== 1 || n.tagName !== 'UL') return n;
      const dl = document.createElement('dl');
      dl.className = 'npd-specs';
      [...n.children].forEach((li) => dl.appendChild(liCell(li)));
      return dl;
    });
    tabs.specs.sects.forEach((s) => { if (!isFeatures(s)) s.nodes = asGrid(s.nodes); });
    /* the product's own type and options lead the first spec grid */
    if (data) {
      const glance = [];
      if (data.type) glance.push(specCell('Type', data.type));
      /* an option whose every value already has its own row below (the Unity's sizes) is not repeated */
      const key = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '');
      const rowLabels = [];
      tabs.specs.sects.forEach((s) => s.nodes.forEach((n) => { if (n.tagName === 'DL') n.querySelectorAll('dt').forEach((dt) => rowLabels.push(key(dt.textContent))); }));
      const listed = (o) => o.values.length > 1 && o.values.every((v) => rowLabels.some((l) => l.startsWith(key(v))));
      (data.options || []).filter((o) => !listed(o)).forEach((o) => glance.push(specCell(o.name, o.values.join(' \u00b7 '))));
      if (glance.length) {
        let target = tabs.specs.sects.find((s) => !isFeatures(s) && s.nodes.some((n) => n.tagName === 'DL'));
        if (!target) { target = { heading: null, repeats: true, nodes: [] }; tabs.specs.sects.unshift(target); }
        let dl = target.nodes.find((n) => n.tagName === 'DL');
        if (!dl) { dl = document.createElement('dl'); dl.className = 'npd-specs'; target.nodes.unshift(dl); }
        glance.reverse().forEach((c) => dl.prepend(c));
      }
    }

    const box = document.createElement('div');
    box.className = 'npd-tabs';
    const bar = document.createElement('div');
    bar.className = 'npd-tabs__bar';
    bar.setAttribute('role', 'tablist');
    bar.setAttribute('aria-label', 'Product information');
    box.appendChild(bar);

    Object.values(tabs).filter((p) => p.sects.some(filled)).forEach((p, i) => {
      const id = 'npd-tab-' + i;
      const tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'npd-tabs__tab';
      tab.id = id;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', id + '-panel');
      tab.setAttribute('aria-selected', String(i === 0));
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.textContent = p.title;
      bar.appendChild(tab);

      const panel = document.createElement('div');
      panel.className = 'npd-tabs__panel rte npd-tabs__panel--' + p.title.toLowerCase().replace(/[^a-z]+/g, '-');
      panel.id = id + '-panel';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', id);
      panel.hidden = i !== 0;
      const shown = p.sects.filter(filled);
      shown.forEach((s, j) => {
        /* FAQ answers sit straight in the panel's grid; other sections are blocks with an h3 subheading */
        if (p === tabs.faq) { s.nodes.forEach((n) => panel.appendChild(n)); return; }
        const block = document.createElement('div');
        block.className = 'npd-tabs__sect' + (j === 0 && !s.heading && p === tabs.desc ? ' npd-tabs__sect--intro' : '');
        if (s.heading && !(s.repeats && shown.length === 1)) {
          const h = document.createElement('h3');
          h.innerHTML = s.heading.innerHTML;
          block.appendChild(h);
        }
        s.nodes.forEach((n) => block.appendChild(n));
        panel.appendChild(block);
      });
      box.appendChild(panel);
    });

    const tabEls = [...bar.children];
    const select = (tab) => {
      tabEls.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
    };
    bar.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t); });
    bar.addEventListener('keydown', (e) => {
      const i = tabEls.indexOf(document.activeElement);
      if (i < 0 || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const next = tabEls[(i + (e.key === 'ArrowRight' ? 1 : tabEls.length - 1)) % tabEls.length];
      select(next);
      next.focus();
    });

    const section = rte.closest('.expanded-inner');
    section.classList.add('npd-tabs-host');
    const content = rte.closest('.tab-content');
    const heading = content.previousElementSibling;
    if (heading && heading.classList.contains('tab-title')) heading.remove();
    content.remove();
    section.prepend(box);
  }

  /* ---------- Size dimensions ----------
     A size option often names only one measure (Coronado: 48"), while the product's own spec rows give the piece's
     full dimensions (48" | 15" Tall: 48"×28"...). Each size tile keeps its name and adds the dimensions below it,
     and the option heading shows the dimensions of the chosen size:
       rectangular  48" L × 28" W × 15" H   (footprint at the start of the row, height from its label)
       round        Ø 48" × 15" H           (a "Diameter" row, or a round piece sized by its diameter)
     Only what the rows state is shown. Display only: the option value, the variant and the cart are unchanged. */
  const specRows = [...document.querySelectorAll('.npd-specs__row')].map((r) => ({
    label: (r.querySelector('dt')?.textContent || '').trim(), value: (r.querySelector('dd')?.textContent || '').trim()
  })).filter((r) => r.label);
  const sizeKey = (s) => s.replace(/\s*[×x|]\s*/g, '|').replace(/\s+/g, ' ').trim().toLowerCase();
  const round = /\bround\b|\bbowl\b|diameter/i.test(document.querySelector('.npd-tabs')?.textContent || '');
  /* Pieces whose listing names only the size: dimensions read from The Outdoor Plus's own spec sheets (Dealer
     Portal "[01] Product Specification Sheets", checked against each drawing: top width, base, overall height). */
  const SHEET_DIMS = {
    'maya-fire-bowl-the-outdoor-plus': { '24"': '24" L × 24" W × 10.75" H', '36"': '36" L × 36" W × 12" H' },
    'maya-fire-water-bowl-the-outdoor-plus': { '24"': '24" L × 24" W × 10.75" H', '36"': '36" L × 36" W × 12" H' },
    'maya-fire-bowl-hammered-copper-the-outdoor-plus': { '24"': '24" L × 24" W × 10" H', '36"': '36" L × 36" W × 12" H' },
    'maya-fire-water-bowl-hammered-copper-the-outdoor-plus': { '24"': '24" L × 24" W × 10" H', '36"': '36" L × 36" W × 12" H' },
    'cazo-fire-bowl-hammered-copper-the-outdoor-plus': { '24"': 'Ø 24" × 10" H', '36"': 'Ø 36" × 12" H' },
    'cazo-fire-water-bowl-hammered-copper-the-outdoor-plus': { '24"': 'Ø 24" × 10" H', '36"': 'Ø 36" × 12" H' },
    'cazo-360-spill-water-feature-the-outdoor-plus': { '30"': 'Ø 30" × 13.5" H', '36"': 'Ø 36" × 13.5" H' },
    'paradise-fall-the-outdoor-plus': { '60"': '60" W × 34" D × 72" H', '96"': '96" W × 34" D × 90" H' },
    'paradise-fall-with-led-the-outdoor-plus': { '60"': '60" W × 34" D × 72" H', '96"': '96" W × 34" D × 90" H' }
  };
  const dimsFor = (v) => {
    const sheet = (SHEET_DIMS[specData.handle] || {})[v];
    if (sheet) return sheet;
    const row = specRows.find((r) => sizeKey(r.label) === sizeKey(v)) || specRows.find((r) => sizeKey(r.label).startsWith(sizeKey(v) + '|'));
    if (!row) return null;
    const tall = row.label.match(/\|\s*((?:approx\.?\s*)?[\d.]+")\s*tall/i);
    const size = row.label.match(/^([\d.]+")/);
    if (!tall || !size) return null;
    const rect = row.value.match(/^([\d.]+)"\s*×\s*([\d.]+)"/);
    if (rect) return `${rect[1]}" L × ${rect[2]}" W × ${tall[1]} H`;
    const dia = row.value.match(/^Diameter\s+([\d.]+")/i);
    if (dia || round) return `Ø ${dia ? dia[1] : size[1]} × ${tall[1]} H`;
    return null;
  };
  info.querySelectorAll('.npd-tiles').forEach((group) => {
    if (!/size/i.test(group.getAttribute('aria-label') || '')) return;
    const dims = {};
    group.querySelectorAll('.npd-tile').forEach((t) => {
      const d = dimsFor(t.dataset.value);
      if (!d) return;
      dims[t.dataset.value] = d;
      const sub = document.createElement('span');
      sub.className = 'npd-tile__dims';
      sub.textContent = d;
      t.querySelector('.npd-tile__label').after(sub);
    });
    if (!Object.keys(dims).length) return;
    group.classList.add('npd-tiles--dims');
    /* the theme rewrites the heading's value whenever the variant changes, so it is re-applied each time */
    const box = group.closest('.product-form__input');
    const select = box?.querySelector('select');
    const heading = () => {
      const span = box?.querySelector('label .lighter');
      const d = select && dims[select.value];
      if (span && d && span.textContent !== d) span.textContent = d;
    };
    heading();
    if (box && 'MutationObserver' in window) new MutationObserver(heading).observe(box, { childList: true, subtree: true, characterData: true });
  });
  /* ---------- Gallery follows the chosen colour ----------
     The theme never moves the gallery when the variant changes, so a page preselected on Black could open
     on a white lifestyle photo. On load, if the first photo isn't of the preselected colour, the gallery moves
     to the first photo whose file name carries that colour (a lifestyle shot when there is one), else to the
     variant's own image. Picking another colour moves it the same way; size and ignition leave it alone.
     Nov 1 2026; the move itself was rewritten Nov 2 (see below). */
  (() => {
    if (!gallery || !variants.length) return;
    const colorSelect = [...info.querySelectorAll('.product__info-block--variant_picker select.select__select')]
      .find((s) => /colou?r|finish/i.test(s.name));
    const wrap = colorSelect && colorSelect.closest('[data-option-index]');
    if (!wrap) return;
    const idx = +wrap.dataset.optionIndex;
    const norm = (t) => (t || '').toLowerCase().replace(/grey/g, 'gray').replace(/[^a-z0-9]/g, '');
    const slides = [...gallery.querySelectorAll('li.slider__slide[data-media-id]:not([data-item-cloned])')];
    const ids = [...new Set(slides.map((s) => s.dataset.mediaId))];
    const fileOf = (id) => {
      const img = slides.find((s) => s.dataset.mediaId === id)?.querySelector('img');
      return norm((img?.getAttribute('src') || img?.currentSrc || '').split('/').pop().split('?')[0]);
    };
    const files = ids.map(fileOf);
    /* The move scrolls the theme's slider straight to the slide (no animation) and checks the slider's own
       scroll position. The old way clicked the thumbnail and read what sat under the gallery's centre; on iPad
       neither held (the click didn't move it, and a sticky header over the photo fooled the check), so the photo
       stayed on the first image. The theme loops its slider with cloned end slides, so the real slide is the one
       without data-item-cloned. Nov 2 2026. */
    const comp = gallery.querySelector('slider-component.product__media') || gallery.querySelector('slider-component');
    const track = comp && comp.querySelector('.slider');
    const slideFor = (id) => track && [...track.children].find((li) => li.dataset.mediaId === String(id) && !li.dataset.itemCloned);
    const thumbFor = (id) => gallery.querySelector(`.slider-pagination a[href="#media-${id}"]`);
    const leftOf = (slide) => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const show = (id, tries = 12) => {
      const slide = slideFor(id);
      if (!slide) { const t = thumbFor(id); if (t) t.click(); return; }
      if (Math.abs(leftOf(slide) - track.scrollLeft) > 2) {
        const snap = track.style.scrollSnapType, beh = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = leftOf(slide);
        track.style.scrollSnapType = snap;
        track.style.scrollBehavior = beh;
        if (comp.update) comp.update();
      }
      const t = thumbFor(id);
      if (t) {
        gallery.querySelectorAll('.slider-pagination a.page-active').forEach((a) => a !== t && a.classList.remove('page-active'));
        t.classList.add('page-active');
      }
      /* The theme can still pull the slider back right after load (resize observer, loop clones), so look again. */
      if (tries > 1) setTimeout(() => {
        if (Math.abs(leftOf(slide) - track.scrollLeft) > 2) show(id, tries - 1);
      }, 250);
    };
    const target = (value) => {
      const key = norm(value);
      const named = key && files.findIndex((f) => f.includes(key));
      if (named >= 0) return ids[named];
      const v = variants.find((x) => x.options[idx] === value && x.featured_media);
      return v ? v.featured_media.id : null;
    };
    const key = norm(colorSelect.value);
    if (key && files[0] && !files[0].includes(key)) {
      const id = target(colorSelect.value);
      const go = () => setTimeout(() => show(id), 150);
      if (id && String(id) !== ids[0]) document.readyState === 'complete' ? go() : window.addEventListener('load', go, { once: true });
    }
    colorSelect.addEventListener('change', () => {
      const id = target(colorSelect.value);
      if (id) show(id);
    });
  })();
})();
